import React, {ReactElement} from 'react';
import {contactUsGridItems} from '../../../lib/constants';
import {contactUsGridType} from '../../../lib/types';

const Grid = ({
  onGridItemClick,
}: {
  onGridItemClick: (item: contactUsGridType) => void;
}): ReactElement => {
  return (
    <div className="grid grid-cols-2 gap-4 contact-us-container sm:grid-cols-4">
      {contactUsGridItems.map((item, index) => {
        return (
          <div
            key={index}
            className="rounded-3xl shadow-md h-28 bg-white contact-us-widget"
            onClick={() => onGridItemClick(item)}>
            <div>
              <div className="h-14 p-2.5 flex justify-center items-center contact-us-widget-img">
                <img className="m-auto" src={item.icon} alt={item.text1} />
              </div>
              <div className="h-14 border-t border-light_grey border-opacity-10 p-2.5 text-center contact-us-widget-text">
                <div className="font-bold text-dark_red text-base">
                  {item.text1}
                </div>
                {item.text2 && (
                  <div className="text-light_grey text-xxs">{item.text2}</div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Grid;
